import produce from 'immer';
import {
  GET_BOOK_NOW_BUTTON_CONFIGS_START,
  GET_BOOK_NOW_BUTTON_CONFIGS_SUCCESS,
  GET_BOOK_NOW_BUTTON_CONFIGS_FAILED,
  SAVE_BOOK_NOW_BUTTON_CONFIGS_START,
  SAVE_BOOK_NOW_BUTTON_CONFIGS_SUCCESS,
  SAVE_BOOK_NOW_BUTTON_CONFIGS_FAILED,
  GET_APPOINTMENT_BUTTON_CONFIGS_START,
  GET_APPOINTMENT_BUTTON_CONFIGS_SUCCESS,
  GET_APPOINTMENT_BUTTON_CONFIGS_FAILED,
  SAVE_APPOINTMENT_BUTTON_CONFIGS_START,
  SAVE_APPOINTMENT_BUTTON_CONFIGS_SUCCESS,
  SAVE_APPOINTMENT_BUTTON_CONFIGS_FAILED
} from 'redux/actions/buttons_configs';


const initialState = {
  bookNowConfigs: {
    isBookNowEnabled: '0',
    isBookNowOnNewWindow: '0',
    bookNowLink: '',
    isLoading: false,
    isError: false
  },
  requestAppointmentConfigs: {
    isRequestAppointmentEnabled: '0',
    isRequestAppointmentOnNewWindow: '0',
    requestAppointmentLink: '',
    isLoading: false,
    isError: false
  }
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_BOOK_NOW_BUTTON_CONFIGS_START: {
      state.bookNowConfigs.isLoading = true;
      break;
    }
    case GET_BOOK_NOW_BUTTON_CONFIGS_SUCCESS: {
      const { config } = action.data;

      state.bookNowConfigs.isBookNowEnabled = config.find((el) => el.path.includes('is_cta_left_link_enabled')).value;
      state.bookNowConfigs.isBookNowOnNewWindow = config.find((el) => el.path.includes('is_cta_left_link_external')).value;
      state.bookNowConfigs.bookNowLink = config.find((el) => el.path === 'theme_design/header_primary/cta_left_link').value;
      state.bookNowConfigs.isLoading = false;
      break;
    }
    case GET_BOOK_NOW_BUTTON_CONFIGS_FAILED: {
      state.bookNowConfigs.isError = true;
      state.bookNowConfigs.isLoading = false;
      break;
    }

    case SAVE_BOOK_NOW_BUTTON_CONFIGS_START: {
      state.bookNowConfigs.isLoading = true;
      break;
    }

    case SAVE_BOOK_NOW_BUTTON_CONFIGS_SUCCESS: {
      const { config } = action.data;

      state.bookNowConfigs.isBookNowEnabled = config.find((el) => el.path.includes('is_cta_left_link_enabled')).value;
      state.bookNowConfigs.isBookNowOnNewWindow = config.find((el) => el.path.includes('is_cta_left_link_external')).value;
      state.bookNowConfigs.bookNowLink = config.find((el) => el.path === 'theme_design/header_primary/cta_left_link').value;
      state.bookNowConfigs.isLoading = false;
      break;
    }

    case SAVE_BOOK_NOW_BUTTON_CONFIGS_FAILED: {
      state.bookNowConfigs.isError = true;
      state.bookNowConfigs.isLoading = false;
      break;
    }

    case GET_APPOINTMENT_BUTTON_CONFIGS_START: {
      state.requestAppointmentConfigs.isLoading = true;
      break;
    }

    case GET_APPOINTMENT_BUTTON_CONFIGS_SUCCESS: {
      const { config } = action.data;

      state.requestAppointmentConfigs.isRequestAppointmentEnabled = config.find((el) => el.path.includes('is_cta_right_link_enabled')).value;
      state.requestAppointmentConfigs.isRequestAppointmentOnNewWindow = config.find((el) => el.path.includes('is_cta_right_link_external')).value;
      state.requestAppointmentConfigs.requestAppointmentLink = config.find((el) => el.path == 'theme_design/header_primary/cta_right_link').value;
      state.requestAppointmentConfigs.isLoading = false;
      break;
    }

    case GET_APPOINTMENT_BUTTON_CONFIGS_FAILED: {
      state.requestAppointmentConfigs.isError = true;
      state.requestAppointmentConfigs.isLoading = false;
      break;
    }

    case SAVE_APPOINTMENT_BUTTON_CONFIGS_START: {
      state.requestAppointmentConfigs.isLoading = true;
      break;
    }

    case SAVE_APPOINTMENT_BUTTON_CONFIGS_SUCCESS: {
      const { config } = action.data;

      state.requestAppointmentConfigs.isRequestAppointmentEnabled = config.find((el) => el.path.includes('is_cta_right_link_enabled')).value;
      state.requestAppointmentConfigs.isRequestAppointmentOnNewWindow = config.find((el) => el.path.includes('is_cta_right_link_external')).value;
      state.requestAppointmentConfigs.requestAppointmentLink = config.find((el) => el.path === 'theme_design/header_primary/cta_right_link').value;
      state.requestAppointmentConfigs.isLoading = false;
      break;
    }
    case SAVE_APPOINTMENT_BUTTON_CONFIGS_FAILED: {
      state.requestAppointmentConfigs.isError = true;
      state.requestAppointmentConfigs.isLoading = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
